import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-add-comments-renderer',
  template: `
    <div class="comments-actions">
      <ng-container *ngIf="!renderInvoiceOnly">
        <app-button-group
          class="btn-edit"
          *ngIf="hasComments"
          [label]="'View/Add Comments'"
          [buttonType]="'Light'"
          [buttonUseCase]="'view'"
          [icon]="'visibility'"
          [iconFillType]="'outlined'"
          [iconWidth]="'15px'"
          [iconHeight]="'15px'"
          (onEmit)="viewComments()"
        ></app-button-group>
        <app-button-group
          class="btn-edit"
          *ngIf="!hasComments"
          [label]="'Add Comments'"
          [buttonType]="'Light'"
          [icon]="'add'"
          [buttonUseCase]="'add'"
          (onEmit)="addComments()"
        ></app-button-group>
      </ng-container>
      <app-button-group
        *ngIf="renderInvoiceOnly"
        class="btn-edit"
        [label]="invoiceLabel"
        [buttonType]="'Light'"
        [buttonUseCase]="'invoice'"
        [icon]="invoiceIcon"
        [iconFillType]="'outlined'"
        [iconWidth]="'15px'"
        [iconHeight]="'15px'"
        (onEmit)="hasInvoice ? openInvoice() : addInvoice()"
      ></app-button-group>
    </div>
  `,
  styles: [
    `
      .comments-actions {
        display: flex;
        gap: 8px;
        align-items: center;
        padding: 4px;
      }

      .comments-actions ::ng-deep emerald-button {
        margin: 0;
      }

      .comments-actions ::ng-deep emerald-button emerald-icon {
        padding-top: 0px !important;
        height: 2rem !important;
      }

      .comments-actions ::ng-deep app-button-group {
        flex-shrink: 0;
      }

      .comments-actions ::ng-deep app-button-group button {
        padding: 4px  8px !important;
      }

      .comments-actions .btn-edit {
        padding-right: 10px !important;
      }
    `,
  ],
})
export class AddCommentsRenderer implements ICellRendererAngularComp {
  params: any;
  hasComments: boolean = false;
  employeeId: string = '';
  procuredOrderId: number = 0;

  hasInvoice: boolean = false;
  invoiceLabel: string = '';
  invoiceIcon: string = '';

  renderInvoiceOnly: boolean = true;

  agInit(params: any): void {
    this.params = params;
    if (typeof params.data?.isComment === 'boolean') {
      this.hasComments = params.data.isComment;
    } else if (typeof params.data?.comments === 'string') {
      this.hasComments = params.data.comments;
    } else {
      const raw = params.value;
      this.hasComments = !!raw && raw.toString().trim().length > 0;
    }
    this.employeeId = params.data?.employeeId || '';
    this.procuredOrderId = params.data?.procuredOrderId || '';

    // Check if this is being used in damage analytics context from cellRendererParams
    const isDamageAnalytics = params.isDamageAnalytics || false;

    this.hasInvoice = !!params.data?.ordersAttachmentUrl;
    this.invoiceLabel = this.hasInvoice ? 'View Attachment' : 'Add Attachment';
    this.invoiceIcon = this.hasInvoice ? 'visibility' : 'attachment';

    // Determine what to render based on context
    if (isDamageAnalytics) {
      // For damage analytics, always show comments
      this.renderInvoiceOnly = false;
    } else if (
      'dateOfOffboarding' in params.data ||
      'assetReturnStatus' in params.data ||
      'employeeStatus' in params.data ||
      'empId' in params.data
    ) {
      // For offboarding context, show comments
      this.renderInvoiceOnly = false;
    } else {
      // For other contexts, show invoice buttons
      this.renderInvoiceOnly = true;
    }
  }

  refresh(params: any): boolean {
    this.agInit(params);
    return true;
  }

  viewComments() {
    const isDamageAnalytics = this.params.isDamageAnalytics || false;

    if (isDamageAnalytics) {
      if ((window as any).openDamageAnalyticsComments) {
        (window as any).openDamageAnalyticsComments(this.employeeId, 'view');
      }
    } else if (this.isOffboardingContext()) {
      if ((window as any).openComments) {
        (window as any).openComments(this.employeeId);
      }
    }
  }

  addComments() {
    const isDamageAnalytics = this.params.isDamageAnalytics || false;
    if (isDamageAnalytics) {
      if ((window as any).openDamageAnalyticsComments) {
        (window as any).openDamageAnalyticsComments(this.employeeId, 'add');
      }
    } else if (this.isOffboardingContext()) {
      if ((window as any).openComments) {
        (window as any).openComments(this.employeeId);
      }
    }
  }

  private isOffboardingContext(): boolean {
    const data = this.params?.data || {};
    return (
      'dateOfOffboarding' in data ||
      'assetReturnStatus' in data ||
      'employeeStatus' in data ||
      'empId' in data
    );
  }
  openInvoice() {
    if ((window as any).openInvoice) {
      (window as any).openInvoice(this.procuredOrderId, 'view-invoice');
    }
  }

  addInvoice() {
    if ((window as any).openInvoice) {
      (window as any).openInvoice(this.procuredOrderId, 'add-invoice');
    }
  }
}
